import {withState} from 'recompose';
import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from './../../../redux/actions';
import {validations} from './../../../lib/validations';
import {withRouter} from 'react-router';

const mapStateToProps = (state: any) => ({
  sales: state.sales,
  initialValues: state.sales.detail,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      sales: bindActionCreators(actions.sales, dispatch),
    },
  };
};

export const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'salesEdit',
    validate: validations.sales,
    enableReinitialize: true,
  }),
  withRouter,
  withState('shippingInfo', 'setShippingInfo', [])
);
